document.addEventListener('DOMContentLoaded', function() {
    // Declare global variables using window object
    window.currentPlayer = null;
    window.currentButton = null;

    // Function to toggle the play/pause icon
    window.toggleIcon = function(player, button) {
        if (player.isPlaying()) {
            button.innerHTML = '<i class="fas fa-circle-pause fa-inverse"></i>';
        } else {
            button.innerHTML = '<i class="fas fa-circle-play fa-inverse"></i>';
        }
    };

    // Function to create WaveSurfer instance and manage play/pause logic
    window.createWaveSurferInstance = function(containerId, buttonId, audioUrl) {
        const wavesurfer = WaveSurfer.create({
            container: containerId,
            waveColor: '#d9e1ea',
            progressColor: '#c2deed',
            cursorColor: 'transparent',
            barWidth: 2,
            height: 80,
            responsive: true
        });

        wavesurfer.load(audioUrl);

        const playButton = document.getElementById(buttonId);
        playButton.addEventListener('click', function() {
            // If another player is currently playing, pause it
            if (window.currentPlayer && window.currentPlayer !== wavesurfer) {
                window.currentPlayer.pause();
                window.toggleIcon(window.currentPlayer, window.currentButton);
            }

            // Toggle play/pause for the clicked player
            if (wavesurfer.isPlaying()) {
                wavesurfer.pause();
            } else {
                wavesurfer.play();
                window.currentPlayer = wavesurfer;
                window.currentButton = playButton;
            }

            // Update the play/pause icon
            window.toggleIcon(wavesurfer, playButton);
        });

        return wavesurfer;
    };
});
